import { type RichiestaModuloDTOPermessiItem } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTOPermessiItem.ts';
import { type IModuleStateMachineRecord } from './ModuleStateMachine.ts';

/**
 * Ritorna vero se l'utente ha i permessi per eseguire l'azione.
 */
export function hasActionPermission(
  record: IModuleStateMachineRecord,
  permissions: RichiestaModuloDTOPermessiItem,
) {
  return Boolean(record.module?.permessi?.includes(permissions));
}
